// extracted by mini-css-extract-plugin
export default {"MenuList":"List_MenuList__-mdAk","save":"List_save__9zXj8","pstfB":"List_pstfB__rgOWg","pstf":"List_pstf__jzbv-"};